module.exports = __webpack_public_path__ + "img/dongtu.8a82ab9f.gif";